<!--
     <SiteMenuItem
       :site="{site_obj}"
     >
-->

<template>
  <div class="sitemenuitem-cont">
    <div class="sitemenuitem-name-cont">
      <!-- <img class="sitemenu-img" :src="site_logo" @error="failed_logo" /> -->
      <div class="sitemenuitem-indent" :style="indent_style"></div>
      <div class="sitemenuitem-name">{{ site.name }}</div>
    </div>
    <v-spacer></v-spacer>
    <div class="sitemenuitem-id" v-if="isAdmin">{{ site.id }}</div>
  </div>
</template>


<style lang="scss">
 @import "@/sass/variables.scss";

 .sitemenuitem-cont {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   flex-direction: row;
   flex-wrap: nowrap;
   color: $primary-darken1;
   min-height: 48px;
 }

 .sitemenuitem-name-cont {
   display: flex;
   align-items: center;
   flex-direction: row;
   flex-wrap: nowrap;
   padding-left: .5em;
 }

 .sitemenu-img {
   width: 96px;
   max-height: 2.8em;
   object-fit: contain;
 }

 .sitemenuitem-indent {
   color: #ddd;
   padding-right: .5em;
 }

 .sitemenuitem-name {
   font-weight: bold;
 }

 .sitemenuitem-id {
   color: rgb(177, 173, 173);
   font-size: 0.8rem;
   margin-right: 6px;
 }
</style>


<script>
 import { mapGetters } from 'vuex';

 export default {
   name: 'SiteMenuItem',

   props: {
     site: Object,
   },

   data: () => ({
     failed: false,
   }),

   computed: {
     ...mapGetters(['isAdmin']),

     depth() {
       return this.site.path.split('/').length - 2;
     },

     indent_style() {
       const px = this.depth * 10;
       return `margin-left: ${px}px;`;
     },

     site_logo() {
       let logo = null;
       if (!this.site.logo) {
         logo = require('./assets/logo_earcon.gif');
       } else {
         logo = this.site.logo;
         if (logo.indexOf('//') <= 2) {
           logo = this.$base + '/' + logo;
         }
       }
       return this.failed ? require('../../assets/image_not_found.png') : logo;
     },

   },

   methods: {
     failed_logo() {
       this.failed = true;
     },
   },
 }
</script>
